import styled from 'styled-components'
import { pageWrapper } from 'styles/mixins/page'

export const Wrapper = styled.div`
  ${pageWrapper(false)}
  span {
    line-height: 1.3;
  }
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
  margin-top: 40px;
  @media screen and (max-width: 860px) {
    grid-template-columns: 1fr;
    margin-top: 0;
  }
`

export const Categories = styled.div`
  @media screen and (max-width: 860px) {
    display: none;
  }
`

export const CategoryItem = styled.div`
  cursor: pointer;
  padding: 16px 16px 16px 32px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.core.VERY_LIGHT_GRAY};
  position: relative;
  &:before {
    position: absolute;
    content: '';
    top: 50%;
    width: 8px;
    height: 8px;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.palette.secondary.MAIN};
    left: 16px;
    transform: translateY(-50%);
  }
`
